<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :label="label"
    item-value="name"
    :item-text="getTagText"
    :rules="rules"
    @input="update"
    :multiple="multiple"
    required
  >
    <template v-slot:item="{ item, attrs }">
      <v-list-item-action>
        <v-checkbox :input-value="attrs.inputValue"></v-checkbox>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{
          item.description || item.name
        }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.explanation">
          <span> {{ item.explanation }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array],
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    update(newValue) {
      if (newValue === undefined) {
        newValue = "";
      }
      this.$emit("input", newValue);
    },
    getTagText(item) {
      if (item.description) {
        return `${item.description} (${item.name})`;
      }

      return item.name;
    },
  },
};
</script>
